import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import { useEffect } from "react";
import SectionUs1 from "./page_us/Solution-US-1/SectionUs1.js";




const PlafondsMursTendus = () =>{
    useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Traitement Acoustique & Feutrine Maroc | Panneaux & Solutions – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Traitement acoustique & feutrine au Maroc avec UNIK SYSTEM : panneaux acoustiques, feutrine et solutions design pour améliorer le confort sonore des bureaux, hôtels et espaces professionnels."
  );

  setMeta(
    "keywords",
    "traitement acoustique & feutrine maroc, feutrine acoustique maroc, panneau acoustique maroc, mur acoustique maroc, isolation phonique maroc, feutrine acoustique maroc, acoustique bureau maroc, UNIK SYSTEM acoustic"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/feutrine-acoustique-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Traitement Acoustique Maroc – Panneaux & Design | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Solutions acoustiques design pour améliorer le confort sonore des espaces professionnels."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/US_ACOUSTIC.932c9c1d7caf1126a467.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/feutrine-acoustique-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Traitement Acoustique Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Panneaux acoustiques et solutions design pour isolation phonique."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/US_ACOUSTIC.932c9c1d7caf1126a467.webp"
  );

  // ========= SCHEMA (PILLAR PAGE SEO) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Expert en traitement acoustique & feutrine et solutions phonique au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Solutions Acoustiques & Feutrine",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Panneaux Acoustiques Décoratifs"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Toile Acoustique Tendu"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Cabine Acoustique Bureau"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-acoustic-main");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-acoustic-main";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi le traitement acoustique ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est l’ensemble des solutions qui permettent de réduire le bruit et améliorer le confort sonore."
        }
      },
      {
        "@type": "Question",
        name: "Quels produits existent ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Panneaux acoustiques & feutrine , toiles tendues, feutrine et cabines acoustiques."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Bureaux, open space, hôtels, restaurants et espaces professionnels."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-acoustic-main");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-acoustic-main";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs1/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;